import {delete_, post, put} from 'common/utils/http';

export const setAlertFeedbackPost = ({payload}) => post('api/v1/feedbacks', payload);
export const updateFeedback = ({payload}) => put(`api/v1/feedbacks/${payload.id}`, {...payload, id: undefined});
export const deleteFeedback = ({payload}) => delete_(`api/v1/feedbacks/${payload}`, {});
